var $6c14ae2b766b652c$exports = {};
$6c14ae2b766b652c$exports = {
    "Empty": `Pr\xe1zdne`
};


export {$6c14ae2b766b652c$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
